import React from 'react'

const NextArrow = ({ size = 16, color = "#2F3237", ...props }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      {...props}
    >
      <path 
        d="M13.3334 7.99988H2.66675" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M10.0002 11.3334C10.0002 11.3334 13.3335 8.87842 13.3335 8.00002C13.3335 7.12162 10.0001 4.66669 10.0001 4.66669" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default NextArrow
